import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from "react-router-dom";

import moment from "moment";
import download from "../../../Images/download.svg";

import { UrlPath } from "../../../config/routeConfig";

import { TopBar } from '../../shared/topBar/TopBar';
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";

import { getTaxEntityDetailAction, getTaxEntityListAction } from "../../actions/investorAccounts";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { sbaAxios } from "../../utils/sbaAxios";
import { getNewIssueDSApi, getTaxEntityStatusDSApi, getTaxStatusDSApi, updateTaxEntityAPI } from "../../../config/apiConfig";
import { AccountDetailsEdit } from "./InvestorAccountEdit";

const emptyAccount={
    "TaxEntityId": 0,
    "TaxEntityName": "",
    "PortfolioId": 0,
    "PortfolioName": "",
    "ContactId": 0,
    "ContactName": "",
    "Abbreviation": "",
    "IsActive": false,
    "InactiveDate": "",
    "TaxEntityStatusId": 0,
    "TaxEntityStatusName": "",
    "InceptionDate": "",
    "TaxId": "",
    "CurrencyId": 0,
    "CurrencyName": "",
    "TaxStatusId": 0,
    "TaxStatusName": "",
    "IsSideLetter": false,
    "ErisaId": 0,
    "Erisa": "",
    "ErisaPercent": 0,
    "NewIssueId": 0,
    "NewIssueName": "",
    "CFTC": false,
    "IsSidePocket": false,
    "IsRestricted": false,
    "Finra5130": 0,
    "Finra5130Name": "",
    "Finra5131": 0,
    "Finra5131Name": "",
    "FormPFId": 0,
    "FormPF": "",
    "BankName": "",
    "WireInstitutionName": "",
    "WireABANumber": "",
    "WireAccountNumber": "",
    "WireBankInformation": "",
    "WireAdditionalInstructions": "",
    "WireNotes": "",
    "StockDeliveryInstructions": "",
    "RegisteredAddress": "",
    "RegisteredCity": "",
    "RegisteredState": "",
    "RegisteredZip": "",
    "RegisteredProvince": "",
    "RegisteredCountry": "",
    "Notes": "",
    "CreatedBy": 0,
    "CreatedByName": "",
    "CreatedDate": "",
    "ModifiedBy": 0,
    "ModifiedByName": "",
    "ModifiedDate": ""
}

export const InvestorAccountAdd = () => {
    const param = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();
    const Gstate = useSelector(state => state);
    const taxEntityList = Gstate.investorAccounts.taxEntityList;
    const taxEntityDetails = Gstate.investorAccounts.taxEntityDetail;
    const [detailedTaxEntity, setDetailedTaxEntity] = useState(taxEntityDetails);

    const Level = [{ BreadCrumb: "Investor >", Routes: `${UrlPath.Investor}` }, { BreadCrumb: `Accounts >`, Routes: `${UrlPath.InvestorAccounts}` },  { BreadCrumb: `Add `, Routes: `${UrlPath.InvestorAccountAdd}` }];




    useEffect(() => {
        setDetailedTaxEntity(taxEntityDetails);
    }, [taxEntityDetails]);

    useEffect(() => {
        document.title = "Account Details"
        dispatch(getTaxEntityListAction());
        if (param.EntityID)
            dispatch(getTaxEntityDetailAction(param.EntityID));
    }, []);

    return (
        <>
            <TopBar label={"Account Details"} />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div className="bg-white p-3 border rounded">
                        <><AccountDetailsEdit details={emptyAccount} addAccount={true} /></>
                    </div>
                </div>
            </div>
        </>
    )
};

